import { createSignal, Show, useContext } from 'solid-js';
import { StyledErrorMessage, StyledFieldContainer, StyledShowpadCodeContainer, StyledSuccessMessage } from './showpad-code-submission-style';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { addShowpadCode } from '../../tools/add-showpad-code';
import { Button } from '../../ui-components/button/button';
import { Heading } from '../../ui-components/heading/heading';
import { StyledTextInput } from '../../ui-components/inputs/text-input';
import { StyledFlexRow } from '../../ui-components/utility-style-components/flex';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';

export const ShowpadCodeSubmission = () => {
    const [errorMessage, setErrorMessage] = createSignal('');
    const [code, setCode] = createSignal('');
    const [submitting, setSubmitting] = createSignal(false);
    const [success, setSuccess] = createSignal(false);

    const { 
        localize,
        userState,
        updateUser,
    } = useContext(AppContext);

    const handleInputChange = (value: string) => {
        setSuccess(false);
        setErrorMessage('');
        setCode(value);
    };

    const submitCode = async () => {
        setSubmitting(true);
        setSuccess(false);
        setErrorMessage('');

        const { success, message } = await addShowpadCode({ showpadCode: code() }, updateUser);
        setSubmitting(false);

        if (!success) {
            if (message === 'invalid-showpad-code') {
                setErrorMessage(localize('invalid-showpad-code', 'The code you entered is invalid'));
            } else {
                console.error(message);
                setErrorMessage(localize('error-has-occurred', 'An error has occurred, please try again later'));
            }

            return;
        }

        setCode('');
        setSuccess(true);
    };

    return (
        <Show when={userState.user}>
            <StyledShowpadCodeContainer>

                <Heading
                    variant='smallGray'
                    tag='h2'
                    noBlockSpacing
                >
                    {localize('course-access-code', 'Course access code')}
                </Heading>

                <StyledFieldContainer>
                    <StyledFlexRow gap='1.5rem' flexWrap='wrap'>
                        <StyledTextInput
                            value={code()}
                            onInput={(e) => handleInputChange(e.currentTarget.value)}
                            placeholder={userState.user?.showpadCode}
                            hasErrors={false}
                            name={'showpad-code'}
                            monospace
                            width='35rem'
                        />

                        <Button
                            label={localize('submit-code', 'Submit code')}
                            onClick={() => submitCode()}
                            variant='secondary'
                            noBlockSpacing
                            disabled={submitting()}
                        />

                        <Show when={submitting()}>
                            <LoadingSpinner size={'2.2rem'} />
                        </Show>
                    </StyledFlexRow>


                    <Show when={errorMessage()}>
                        <StyledErrorMessage>
                            {errorMessage()}
                        </StyledErrorMessage>
                    </Show>

                    <Show when={success()}>
                        <StyledSuccessMessage>
                            {localize('showpad-code-successfully-added', 'Showpad code successfully added')}
                        </StyledSuccessMessage>
                    </Show>
                </StyledFieldContainer>

            </StyledShowpadCodeContainer>
        </Show>
    );
};